export default "__VITE_ASSET__Qw9$9qCO__"